import * as layouts from "layouts"
import * as routing from "brandguard/routing"
import * as bgapprovals from "brandguard/display/approval"

export function upload(): JSX.Element {
	return (
		<bgapprovals.Container urlgen={routing.document.approval.upload}>
			<layouts.containers.flex
				flexDirection="column"
				height="100%"
				overflow="hidden"
				data-testid="doc-brandguard-upload"
			>
				<bgapprovals.DocumentActiveLink imageUrlgen={routing.image.approval.upload} textUrlgen={routing.text.approval.upload} videoUrlgen={routing.video.approval.upload} />
				<bgapprovals.navigation.DocumentsNav />
				<bgapprovals.documents.UploadDisplay />
			</layouts.containers.flex>
		</bgapprovals.Container>
	)
}

export function review(): JSX.Element {
	return (
		<bgapprovals.Container urlgen={routing.document.approval.review}>
			<layouts.containers.flex
				flexDirection="column"
				height="100%"
				overflow="hidden"
				data-testid="doc-brandguard-review"
			>
				<bgapprovals.DocumentActiveLink imageUrlgen={routing.image.approval.review} textUrlgen={routing.text.approval.review} videoUrlgen={routing.video.approval.review} />
				<bgapprovals.navigation.DocumentsNav />
				<bgapprovals.documents.ReviewDisplay />
			</layouts.containers.flex>
		</bgapprovals.Container>
	)
}

export function approved(): JSX.Element {
	return (
		<bgapprovals.Container urlgen={routing.document.approval.approved}>
			<layouts.containers.flex
				flexDirection="column"
				height="100%"
				overflow="hidden"
				data-testid="doc-brandguard-approved"
			>
				<bgapprovals.DocumentActiveLink imageUrlgen={routing.image.approval.approved} textUrlgen={routing.text.approval.approved} videoUrlgen={routing.video.approval.approved} />
				<bgapprovals.navigation.DocumentsNav />
				<bgapprovals.documents.ApprovedDisplay />
			</layouts.containers.flex>
		</bgapprovals.Container>
	)
}

export function rejected(): JSX.Element {
	return (
		<bgapprovals.Container urlgen={routing.document.approval.rejected}>
			<layouts.containers.flex
				flexDirection="column"
				height="100%"
				overflow="hidden"
				data-testid="doc-brandguard-rejected"
			>
				<bgapprovals.DocumentActiveLink imageUrlgen={routing.image.approval.rejected} textUrlgen={routing.text.approval.rejected} videoUrlgen={routing.video.approval.rejected} />
				<bgapprovals.navigation.DocumentsNav />
				<bgapprovals.documents.RejectedDisplay />
			</layouts.containers.flex>
		</bgapprovals.Container>
	)
}
